export const WorkData= [
    {
        company:"Middleman-Tec",
        Role:"Full-Stack Developer (Part-Time)",
        dateJoining: "01-05-2021",
        dateEnd:"Present",
        companyLogo: require("../../assets/mmd.png"),
        work:"Developing Websites for Clients All Over Africa."

    },
    {
        company:"ALX_AFRICA",
        Role:"Student",
        dateJoining: "01-06-2021",
        dateEnd:"01-07-2022",
        companyLogo: require("../../assets/alx.png"),
        work:"Software Engineering Certificate(1-year). The Program is done under the partnership of ALX and Holberton School.",

    }
]